import React from "react";
import { currentLocals } from "../languages/languages.js";
import "../styles/OnBoarding.css";
import { Typography } from "@mui/material";

/*
function actionStep_1() {
  ocultawhatisnewViewPaternAssistant();
  ocultawhatisnewPatAssistantGradCtrl();
  ocultawhatisnewPatAssistantZoomPan();
}
function actionStep_2() {
  muestrawhatisnewViewPaternAssistant();
  ocultawhatisnewPatAssistantGradCtrl();
  ocultawhatisnewPatAssistantZoomPan();
}
function actionStep_3() {}
function actionStep_4() {}
function actionStep_5() {}
function actionStep_6() {}
function actionStep_7() {}
*/
function muestrawhatisnewViewPaternAssistant() {
  var img = document.getElementById("ViewPaternAssistant");
  //img.style.display = "block";
  img.classList.remove("whatisnewViewPaternAssistantHide");
  img.classList.add("whatisnewViewPaternAssistantShow");
}

function ocultawhatisnewViewPaternAssistant() {
  var img = document.getElementById("ViewPaternAssistant");
  //img.style.display = "none";
  img.classList.remove("whatisnewViewPaternAssistantShow");
  img.classList.add("whatisnewViewPaternAssistantHide");
}
/*
function muestrawhatisnewPatAssistantGradCtrl() {
  var img = document.getElementById("PatAssistantGradCtrl");
  //img.style.display = "block";
  img.classList.remove("whatisnewPatAssistantGradCtrlHide");
  img.classList.add("whatisnewPatAssistantGradCtrlShow");
}

function ocultawhatisnewPatAssistantGradCtrl() {
  var img = document.getElementById("PatAssistantGradCtrl");
  //img.style.display = "none";
  img.classList.remove("whatisnewPatAssistantGradCtrlShow");
  img.classList.add("whatisnewPatAssistantGradCtrlHide");
}

function muestrawhatisnewPatAssistantZoomPan() {
  var img = document.getElementById("PatAssistantZoomPan");
  //img.style.display = "block";
  img.classList.remove("whatisnewPatAssistantZoomPanHide");
  img.classList.add("whatisnewPatAssistantZoomPanShow");
}

function ocultawhatisnewPatAssistantZoomPan() {
  var img = document.getElementById("PatAssistantZoomPan");
  //img.style.display = "none";
  img.classList.remove("whatisnewPatAssistantZoomPanShow");
  img.classList.add("whatisnewPatAssistantZoomPanHide");
}
*/
function getWhatIsNewSteps(locale) {
  locale = locale === undefined ? "EN" : locale;

  let tourConfig = [
    {
      selector: '[data-tut="reactour__converterspool"]',
      position: "right",
      content: function DemoHelperComponent_1() {
        return (
          <div>
            {" "}
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).whatisnew.Get_more_information}
            </Typography>
            {/*<div className="tourdefaultfonttitle">{currentLocals(locale).whatisnew.Get_more_information}</div>*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.Motif_links_special_grading}</div>
            {/* <Typography sx={{ marginRight: 2, color: "secondary.main" }} variant="span">
              {currentLocals(locale).whatisnew.Motif_links_special_grading}
        </Typography>*/}
          </div>
        );
      },
      action: () => ocultawhatisnewViewPaternAssistant(),
    },
    {
      selector: '[data-tut="reactour__whatisnewViewPaternAssistant"]',
      position: "top",
      content: function DemoHelperComponent_2() {
        return (
          <div>
            {" "}
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).whatisnew.View_converted_files_Pattern_Assistant}
            </Typography>
            {/* <div className="tourdefaultfonttitle">  {currentLocals(locale).whatisnew.View_converted_files_Pattern_Assistant}
        </div>*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.Detailed_view}</div>
          </div>
        );
      },
      action: () => muestrawhatisnewViewPaternAssistant(),
    },
    /*
    {
      selector: '[class="KUISpanTooltip"]',
      position: "center",
      content: function DemoHelperComponent_3() {
        return (
          <div>
            {" "}
            <div className="tourdefaultfonttitle">{currentLocals(locale).whatisnew.Pan_and_zoom}</div> <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.To_move_To_zoom}</div>
            <img src={panandzoom} className="gif_tour_step" />
          </div>
        );
      },
      action: () => ocultawhatisnewViewPaternAssistant(),
    },
    {
      selector: '[class="KUISpanTooltip"]',
      position: "center",
      content: function DemoHelperComponent_4() {
        return (
          <div>
            {" "}
            <div className="tourdefaultfonttitle">{currentLocals(locale).whatisnew.Check_scaling}</div> <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.Check_scaling_drop_configuration}</div>
            <img src={gradingcheck} className="gif_tour_step" />
          </div>
        );
      },
      action: () => ocultawhatisnewViewPaternAssistant(),
    },
*/
    /*{
      selector: '[data-tut="reactour__downloadall"]',
      position: "top",
      content: function DemoHelperComponent_2() {
        return (
          <div>
            {" "}
            <div className="tourdefaultfonttitle">{currentLocals(locale).whatisnew.Download_all}</div> <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.Click_download_all}</div>
          </div>
        );
      },
      action: () => ocultawhatisnewViewPaternAssistant(),
    },*/
    /*
    {
      selector: '[data-tut="reactour__conversionhelpbutton"]',
      position: "left",
      content: function DemoHelperComponent_5() {
        return (
          <div>
            {" "}
            <div className="tourdefaultfonttitle">
              {currentLocals(locale).whatisnew.Discover_the_other_new_features}
            </div>
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.Check_out_MyLectra}</div>
          </div>
        );
      },
      action: () => ocultawhatisnewViewPaternAssistant(),
      roundedStep: true,
    },*/
    {
      //selector: '[data-tut="reactour__conversionhelpbutton"]',
      selector: '[data-testid="muiheader-help-header-icon"]',
      position: "bottom",
      content: function DemoHelperComponent_5() {
        return (
          <div>
            {" "}
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).whatisnew.More_information}
            </Typography>
            {/* <div className="tourdefaultfonttitle">{currentLocals(locale).whatisnew.More_information}</div>*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.Click_here_to_see_all_the_news}</div>
          </div>
        );
      },
      action: () => ocultawhatisnewViewPaternAssistant(),
    },
    /*
    {
      selector: '[data-tut="reactour__center"]',
      position: "center",
      content: function DemoHelperComponent_6() {
        return (
          <div>
            {" "}
            <div className="tourdefaultfonttitle">{currentLocals(locale).whatisnew.Up_to_you}</div> <br />
            <div className="tourdefaultfont">{currentLocals(locale).whatisnew.completed_guided_tour}</div>
          </div>
        );
      },
      action: () => ocultawhatisnewViewPaternAssistant(),
    },*/
  ];

  return tourConfig;
}

export default getWhatIsNewSteps;
